export const getErrorMessage = (error) => {
    if (error.response?.data?.message) {
        return error.response.data.message;
    }
    
    if (error.message) {
        return error.message;
    }

    if (!navigator.onLine) {
        return 'No internet connection. Please check your network.';
    }

    return 'Something went wrong. Please try again.';
};

export const isAuthError = (error) => {
    return error.response?.status === 401 || error.response?.status === 403;
}; 